import type { AccessFunction, AccessService, RequiredAccess } from "~domain/auth/models/access-model.ts";

export const VOLTEXPLOIT_REQUIRED_ACCESS: RequiredAccess = {
  service: "phoning" as AccessService,
  function: "callManagement" as AccessFunction,
};
